import { FunctionComponent, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { URLS } from '../../config';

export interface ContainerComponentChildrenArgs {
  handleClick: () => void;
}

export interface ContainerComponentProps {
  children: (args: ContainerComponentChildrenArgs) => JSX.Element;
}

const ContainerComponent: FunctionComponent<ContainerComponentProps> = ({
  children,
}) => {
  const { length, goBack, push } = useHistory();

  const handleClick = useCallback(() => {
    if (length === 0) {
      push(URLS.home);
      return;
    }
    goBack();
  }, [length, goBack, push]);

  return children({
    handleClick,
  });
};

ContainerComponent.displayName = 'Backlink-container';

export default ContainerComponent;
